import { useState } from 'react';
import { FormControl, Stack } from '@chakra-ui/react';
import { Field } from 'formik';

import FieldError from 'components/forms/new/FieldError';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import NameField from 'components/forms/new/formikFormFields/NameField';
import { FormLabel } from '@/components/v4';
import {
    formInputStyles,
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';

const CountryAlpha2Field = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            isRequired
            isInvalid={!!errors.alpha2 && touched.alpha2}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <FormLabel sx={formLabelStyling(darkMode)}>Alpha-2</FormLabel>
                <Field
                    name="alpha2"
                    render={({ field }) => (
                        <NameField
                            {...field}
                            pl={2}
                            placeholder="Please enter a Alpha-2"
                            onKeyPress={(event) => {
                                const currentInput =
                                    event.target.value + event.key;
                                if (
                                    !/^[A-Z]$/.test(event.key) ||
                                    currentInput.length > 2
                                ) {
                                    event.preventDefault();
                                }
                            }}
                            darkMode={darkMode}
                        />
                    )}
                />
                {isHovered && (
                    <FieldToolTip
                        label="eg. US"
                        ariaLabel="country-alpha2-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FieldError isDrawer={false}>{errors?.alpha2}</FieldError>
        </FormControl>
    );
};

export default CountryAlpha2Field;
